import { createSettingsSelectors } from '@capital-access/common/user';
import { APPLICATION_SELECTED_SECURITY_KEY } from '../constants';
import { SelectedSecuritySettings } from '../models';

export const { selectSettings: getRawApplicationSelectedSecuritySettings } = createSettingsSelectors(
  SelectedSecuritySettings,
  APPLICATION_SELECTED_SECURITY_KEY
);
